export const ConfigMapTypes = {
  location: {
    lat: 16.06396,
    lng: 108.213479,
  },
  zoom: 12,
};

export const ConfigMapHoiAn = {
  location: {
    lat: 16.06396,
    lng: 108.213479,
  },
  zoom: 12,
};

export const MapOptionStyle = [
  {
    featureType: 'poi',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'transit.station',
    stylers: [{ visibility: 'off' }],
  },
];
